import { useMemo } from 'react';
import { useGetDocumentPackageSummaryQuery } from '../api';
export const useDocumentPackageSummary = (projectId, documentPackageId, categoryType) => {
    const request = {
        projectId,
        documentPackageId,
        ...(categoryType !== undefined ? { categoryType } : {}),
    };
    const { data: summaryList, isLoading, isFetching, isError, error, refetch, } = useGetDocumentPackageSummaryQuery(request);
    return useMemo(() => {
        const summary = summaryList?.[0] ?? null;
        return {
            summary,
            isLoading,
            isFetching,
            isError,
            error,
            refetch,
        };
    }, [summaryList, isLoading, isFetching, isError, error, refetch]);
};
